import React from 'react';

/*
    - ihoDesignSystem
*/
import { Alert, Container, Grid, Image } from '@iho-design-system/Loader';

/*
    - component
*/
import BannerComponent from '../components/dashboard/Banner';
import ChartComponent from '../components/dashboard/Chart';
import EditFormComponent from '../components/dashboard/EditForm';
import PaymentModalComponent from '../components/dashboard/PaymentModal';
import RankComponentB2B from '../components/dashboard/Rank-b2b';
import RankComponentB2C from '../components/dashboard/Rank-b2c';
import ReserveComponent from '../components/dashboard/Reserve';
import TitleComponent from '../components/dashboard/Title';

/*
    - TDMBanner
*/
import TDMDesktop from '../assets/images/dashboard/tdm-desktop.png';
import TDMMobile from '../assets/images/dashboard/tdm-mobile.png';

/*
    - api
*/
import getAPI from '../api/get';

import buyAmountReportAPI from '../api/get/BuyAmountReport';
import dashboardBoxesDataAPI from '../api/get/DashboardBoxesData';
import totalReservesPriceAPI from '../api/get/TotalReservesPrice';

const Dashboard = ({ reloadHeaderProps }) => {

    /*
        - defaultData
    */
    const type = localStorage.getItem('type');
    const [dashboardData, setDashoardData] = React.useState({
        activeReserves: '',
        bankAccount: '',
        buyAmountReport: '',
        citiesAndStates: '',
        dashboardBoxesData: '',
        totalReservesPrice: '',
        nightReservesCount: '',
        passengerProfile: '',
        userPlanDetails: '',
        userProfile: '',
        userRegisterTypes: '',
        walletBalance: '',
        userCompaniesHistory: ''
    });
    const [reloadDashboard, setReloadDashboard] = React.useState('');
    const [reportType, setReportType] = React.useState(1);

    /*
        - alert
    */
    const [alert, setAlert] = React.useState('');
    const [alertColor, setAlertColor] = React.useState('success');
    const [alertStatus, setAlertStatus] = React.useState('d-none');
    const alertProps = (config) => {
        setAlert(config[1])
        setAlertColor(config[0]);
        setAlertStatus('d-flex');
        setTimeout(() => {
            setAlertStatus('d-none');
        }, 2500);
    }

    /*
        - fetchData
    */
    React.useEffect(() => {
        const fetchData = async () => {

            let activeReserveParameters = {
                ctrl: 'UserProfile',
                method: 'GetActiveReserves',
                query: '5'
            };

            let bankAccountParameters = {
                ctrl: 'BankAccount',
                method: 'GetAll',
                query: ''
            }

            let citiesAndStatesParameters = {
                ctrl: 'Common',
                method: 'StateAndCities',
                query: ''
            }

            let buyAmountReportParameters = {
                ReportType: reportType
            };

            let nightReserveCountParameters = {
                ctrl: 'UserProfile',
                method: 'NightReservesCount',
                query: ''
            };

            let passengerProfileParameters = {
                ctrl: 'UserProfile',
                method: 'GetPassengerProfile',
                query: ''
            }

            let userPlanDetailsParameters = {
                ctrl: 'UserProfile',
                method: 'GetUserPlanDetails',
                query: ''
            }

            let userProfileParameters = {
                ctrl: 'UserProfile',
                method: 'GetUserProfile',
                query: ''
            }

            let walletBalanceParameters = {
                ctrl: 'UserProfile',
                method: 'GetWalletBalanceEx',
                query: ''
            }

            let userCompaniesHistoryParameters = {
                ctrl: 'UserProfile',
                method: 'GetuserCompaiesHistory',
                query: ''
            }

            setDashoardData({
                activeReserves: await getAPI(activeReserveParameters),
                bankAccount: await getAPI(bankAccountParameters),
                buyAmountReport: await buyAmountReportAPI(buyAmountReportParameters),
                citiesAndStates: await getAPI(citiesAndStatesParameters),
                dashboardBoxesData: await dashboardBoxesDataAPI(),
                totalReservesPrice: await totalReservesPriceAPI(),
                nightReservesCount: await getAPI(nightReserveCountParameters),
                passengerProfile: await getAPI(passengerProfileParameters),
                userPlanDetails: await getAPI(userPlanDetailsParameters),
                userProfile: await getAPI(userProfileParameters),
                walletBalance: await getAPI(walletBalanceParameters),
                userCompaniesHistory: await getAPI(userCompaniesHistoryParameters)
            });
        }
        fetchData();

    }, [reloadDashboard, reportType]);

    /*
        - reloadDashboardProps
    */
    const reloadDashboardProps = (reloadDashboardProps) => {
        setReloadDashboard(reloadDashboardProps);
        reloadHeaderProps(reloadDashboardProps);
    }

    /*
        - ReportTypeProps
    */
    const ReportTypeProps = (ReportTypeProps) => {
        setReportType(ReportTypeProps);
    }

    /*
        - userRequirement
    */
    let requirement = true;
    if (type === 'B2C' && (dashboardData.userProfile.status === 200 && (dashboardData.userProfile.data.firstName === '' || dashboardData.userProfile.data.firstName === null || dashboardData.userProfile.data.lastName === '' || dashboardData.userProfile.data.lastName === null || dashboardData.userProfile.data.mobile === '' || dashboardData.userProfile.data.mobile === null))) {
        requirement = false;
    }

    /*
        - loadTDMPage
    */
    const loadTDMPage = () => {
        window.location.href = 'https://www.iranhotelonline.com/babolsar-hotels/%D9%87%D8%AA%D9%84-%D9%BE%D9%86%D8%AC-%D8%B3%D8%AA%D8%A7%D8%B1%D9%87-%D9%85%DB%8C%D8%B2%D8%A8%D8%A7%D9%86/';
    }

    /*
        - componentData
    */
    let bannerData = [];
    bannerData.walletBalance = dashboardData.walletBalance;
    bannerData.bankAccount = dashboardData.bankAccount;

    let editFormData = [];
    editFormData.userProfile = dashboardData.userProfile;
    editFormData.passengerProfile = dashboardData.passengerProfile;
    editFormData.citiesAndStates = dashboardData.citiesAndStates;

    let rankData = [];
    rankData.userPlanDetails = dashboardData.userPlanDetails;
    rankData.nightReservesCount = dashboardData.nightReservesCount;
    rankData.totalReservesPrice = dashboardData.totalReservesPrice;

    let reserveData = [];
    reserveData.activeReserves = dashboardData.activeReserves;
    reserveData.userCompaniesHistory = dashboardData.userCompaniesHistory;

    let titleData = [];
    titleData.dashboardBoxesData = dashboardData.dashboardBoxesData;

    let chartData = [];
    chartData.buyAmountReport = dashboardData.buyAmountReport;

    /*
        - scale
    */
    const screenWidth = window.innerWidth;
    let scale = '';
    if (screenWidth > 1400) {
        scale = 'xx-large';
    } else if (screenWidth <= 1400 && screenWidth > 1200) {
        scale = 'x-large';
    } else if (screenWidth <= 1200 && screenWidth > 992) {
        scale = 'large'
    } else if (screenWidth <= 992 && screenWidth > 768) {
        scale = 'medium'
    } else if (screenWidth <= 768 && screenWidth > 576) {
        scale = 'small'
    } else if (screenWidth <= 576) {
        scale = 'x-small'
    }

    return (
        <React.Fragment>
            {type === 'B2C' &&
                <React.Fragment>
                    {(scale === 'xx-large' || scale === 'x-large' || scale === 'large') &&
                        <Container
                            size='lg'>
                            <Grid>
                                <Grid.Wrapper>
                                    {!requirement &&
                                        <Grid.Item
                                            size='col-12'>
                                            <Alert
                                                className={`w-100 position-static`}
                                                color='danger'
                                                ms={{
                                                    boxShadow: 'none !important'
                                                }}>
                                                کاربر گرامی، به منظور دسترسی به تمامی امکانات، لطفا اطلاعات ستاره دار فرم زیر را تکمیل نمایید.
                                            </Alert>
                                        </Grid.Item>
                                    }
                                    <Grid.Item
                                        size='col-5'>
                                        <EditFormComponent
                                            props={editFormData}
                                            alertProps={alertProps}
                                            reloadDashboardProps={reloadDashboardProps} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-7'>
                                        <BannerComponent
                                            props={bannerData}
                                            alertProps={alertProps}
                                            reloadDashboardProps={reloadDashboardProps} />
                                        <RankComponentB2C
                                            props={rankData} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-12'>
                                        <ReserveComponent
                                            props={reserveData}
                                            alertProps={alertProps}
                                            reloadDashboardProps={reloadDashboardProps} />
                                    </Grid.Item>
                                </Grid.Wrapper>
                            </Grid>
                        </Container>
                    }
                    {(scale === 'medium' || scale === 'small') &&
                        <Container
                            size='lg'>
                            <Grid>
                                <Grid.Wrapper>
                                    {!requirement &&
                                        <Grid.Item
                                            size='col-12'>
                                            <Alert
                                                className={`w-100`}
                                                color='danger'
                                                ms={{
                                                    boxShadow: 'none !important',
                                                    position: 'static !important'
                                                }}>
                                                کاربر گرامی، به منظور دسترسی به تمامی امکانات داشبورد، لطفا اطلاعات ستاره دار فرم زیر را تکمیل نمایید.
                                            </Alert>
                                        </Grid.Item>
                                    }
                                    <Grid.Item
                                        size='col-5'>
                                        <EditFormComponent
                                            props={editFormData}
                                            alertProps={alertProps}
                                            reloadDashboardProps={reloadDashboardProps} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-7'>
                                        <BannerComponent
                                            props={bannerData}
                                            alertProps={alertProps}
                                            reloadDashboardProps={reloadDashboardProps} />
                                        <RankComponentB2C
                                            props={rankData} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-12'>
                                        <ReserveComponent
                                            props={reserveData}
                                            alertProps={alertProps}
                                            reloadDashboardProps={reloadDashboardProps} />
                                    </Grid.Item>
                                </Grid.Wrapper>
                            </Grid>
                        </Container>
                    }
                    {scale === 'x-small' &&
                        <Container
                            size='lg'>
                            <Grid>
                                <Grid.Wrapper>
                                    <Grid.Item
                                        size='col-12'>
                                        <BannerComponent
                                            props={bannerData}
                                            alertProps={alertProps}
                                            reloadDashboardProps={reloadDashboardProps} />
                                        <RankComponentB2C
                                            props={rankData} />
                                    </Grid.Item>
                                    {!requirement &&
                                        <Grid.Item
                                            size='col-12'>
                                            <Alert
                                                className={`w-100`}
                                                color='danger'
                                                ms={{
                                                    boxShadow: 'none !important',
                                                    position: 'static !important'
                                                }}>
                                                کاربر گرامی، به منظور دسترسی به تمامی امکانات داشبورد، لطفا اطلاعات ستاره دار فرم زیر را تکمیل نمایید.
                                            </Alert>
                                        </Grid.Item>
                                    }
                                    <Grid.Item
                                        size='col-12'>
                                        <EditFormComponent
                                            props={editFormData}
                                            alertProps={alertProps}
                                            reloadDashboardProps={reloadDashboardProps} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-12'>
                                        <ReserveComponent
                                            props={reserveData}
                                            alertProps={alertProps}
                                            reloadDashboardProps={reloadDashboardProps} />
                                    </Grid.Item>
                                </Grid.Wrapper>
                            </Grid>
                        </Container>
                    }
                </React.Fragment>
            }
            {type === 'B2B' &&
                <React.Fragment>
                    {(scale === 'xx-large' || scale === 'x-large' || scale === 'large') &&
                        <Container
                            size='lg'>
                            <React.Fragment>
                                <TitleComponent
                                    props={titleData} />
                            </React.Fragment>
                            <Grid>
                                <Grid.Wrapper>
                                    <Grid.Item
                                        size='col-12'>
                                        <Image
                                            className={`pointer`}
                                            onClick={loadTDMPage}
                                            src={TDMDesktop} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>
                                        <ChartComponent
                                            props={chartData}
                                            ReportTypeProps={ReportTypeProps} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>
                                        <RankComponentB2B
                                            props={rankData} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-12'>
                                        <ReserveComponent
                                            props={reserveData}
                                            alertProps={alertProps}
                                            reloadDashboardProps={reloadDashboardProps} />
                                    </Grid.Item>
                                </Grid.Wrapper>
                            </Grid>
                        </Container>
                    }
                    {(scale === 'medium' || scale === 'small') &&
                        <Container
                            size='lg'>
                            <React.Fragment>
                                <TitleComponent
                                    props={titleData} />
                            </React.Fragment>
                            <Grid>
                                <Grid.Wrapper>
                                    <Grid.Item
                                        size='col-12'>
                                        <Image
                                            className={`pointer`}
                                            onClick={loadTDMPage}
                                            src={TDMDesktop} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-12'>
                                        <RankComponentB2B
                                            props={rankData} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-12'>
                                        <ChartComponent
                                            props={chartData}
                                            ReportTypeProps={ReportTypeProps} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-12'>
                                        <ReserveComponent
                                            props={reserveData}
                                            alertProps={alertProps}
                                            reloadDashboardProps={reloadDashboardProps} />
                                    </Grid.Item>
                                </Grid.Wrapper>
                            </Grid>
                        </Container>
                    }
                    {scale === 'x-small' &&
                        <Container
                            size='lg'>
                            <React.Fragment>
                                <TitleComponent
                                    props={titleData} />
                            </React.Fragment>
                            <Grid>
                                <Grid.Wrapper>
                                    <Grid.Item
                                        size='col-12'>
                                        <Image
                                            className={`pointer`}
                                            onClick={loadTDMPage}
                                            src={TDMMobile} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-12'>
                                        <RankComponentB2B
                                            props={rankData} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-12'>
                                        <ChartComponent
                                            props={chartData}
                                            ReportTypeProps={ReportTypeProps} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-12'>
                                        <ReserveComponent
                                            props={reserveData}
                                            alertProps={alertProps}
                                            reloadDashboardProps={reloadDashboardProps} />
                                    </Grid.Item>
                                </Grid.Wrapper>
                            </Grid>
                        </Container>
                    }
                </React.Fragment>
            }
            <PaymentModalComponent />
            <Alert
                className={`alert ${alertStatus}`}
                color={alertColor}
                ms={{
                    bottom: '75px !important'
                }}>
                {alert}
            </Alert>
        </React.Fragment>
    );

}

export default Dashboard;